import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import { Glyphicon, Nav, Navbar, MenuItem, NavItem, NavDropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { AdminLinkContainer } from '../AdminLinkContainer';
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';
import AuthService from "../../services/auth.service";
import '../../content/css/Topbar.css';
import ExportDocumentModal from './ExportDocumentModal';
import { PrivateLinkContainer } from '../PrivateLinkContainer';

class Topbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasDocSelected: false,
            hasReportSelected: false,
            docTitle: "",
            reportTitle: ""
        };

        this.authService = new AuthService();
    }

    componentDidMount() {
        this.updateState();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.analysis.id !== prevProps.analysis.id) {
            this.updateState();
        }

        if (prevProps.analysis.portfolioAnalyses !== this.props.analysis.portfolioAnalyses) {
            this.updateState();
        }

        if (prevProps.contractReviewer.id != this.props.contractReviewer.id) {
            this.updateState();
        }

        if (prevProps.contractReviewer.analyzedDocuments != this.props.contractReviewer.analyzedDocuments) {
            this.updateState();
        }

        if (this.props.exceptions != prevProps.exceptions && this.props.exceptions.length > 0) {
            throw this.props.exceptions[0];
        }
    }

    updateState = () => {
        let hasReportSelected = this.props.analysis.id && this.props.analysis.id != "";
        let hasDocSelected = this.props.contractReviewer.id && this.props.contractReviewer.id != "";
        let report = this.props.analysis.portfolioAnalyses[this.props.analysis.id];
        let reportTitle = hasReportSelected && report ? "Report" : "";
        let doc = this.getDocument(this.props.contractReviewer.id, this.props.analysis.id);
        let docTitle = hasDocSelected && doc ? doc.fileName : "";

        this.setState({
            hasDocSelected,
            hasReportSelected,
            reportTitle,
            docTitle
        });
    }

    getDocument = (id, reportId) => {
        let doc = {};
        //id = reportId == "" ? id : `${reportId}-${id}`;
        doc = this.props.contractReviewer.analyzedDocuments[id];

        return doc;
    }

    render() {
        let isAuthenticated = this.authService.isAuthenticated();
        let isGuest = this.authService.isGuest();
        let linkBase = this.state.hasReportSelected ? `/reports/${this.props.analysis.id}/document` : "";
        return (
            <Navbar fixedTop inverse collapseOnSelect className="topbar-new">
                <Navbar.Header>
                    <Navbar.Brand>
                        {this.state.hasReportSelected &&
                            <LinkContainer to={`/reports/${this.props.analysis.id}`}>
                                <span className="title">{this.state.reportTitle}</span>
                            </LinkContainer>
                        }
                        {this.state.hasDocSelected &&
                            <React.Fragment>
                                {this.state.hasReportSelected &&
                                    <span className="title"> {'/'} </span>
                                }
                                <span className="title">{this.state.docTitle}</span>
                            </React.Fragment>
                        }

                        {!this.state.hasReportSelected && !this.state.hasDocSelected &&
                            <span className="title">Legly</span>
                        }
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    {this.state.hasDocSelected &&
                        <React.Fragment>
                            <Nav>
                                <IndexLinkContainer to={`${linkBase}/${this.props.contractReviewer.id}`}>
                                    <NavItem eventKey={1}>
                                        Overview
                                    </NavItem>
                                </IndexLinkContainer >
                                <IndexLinkContainer to={`${linkBase}/${this.props.contractReviewer.id}/viewer/1`}>
                                    <NavItem eventKey={2} href="#">
                                        View document
                                    </NavItem>
                                </IndexLinkContainer >
                                <IndexLinkContainer to={`${linkBase}/${this.props.contractReviewer.id}/missing`}>
                                    <NavItem eventKey={3} href="#">
                                        Missing concepts
                                    </NavItem>
                                </IndexLinkContainer >
                            </Nav>
                            {/*<Nav pullRight>
                                <NavItem eventKey={2} href="#">
                                    Export
                                </NavItem>
                            </Nav>*/}
                        </React.Fragment>
                    }
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default connect(
    state => {
        const { contractReviewer, analysis } = state;
        return {
            contractReviewer,
            analysis
        };
    },
    dispatch => bindActionCreators(actions, dispatch)
)(Topbar);


// WEBPACK FOOTER //
// ./src/components/Home/Topbar.js